// Helper de accesibilitate pentru elemente non-native făcute interactive (ex. un <div>/<li>
// cu role="button"): declanșează acțiunea la Enter sau Space, ca un buton real.
//
// Folosire:
//   <div role="button" tabIndex={0} onClick={go} onKeyDown={(e) => handleActivateKey(e, go)} />
export const handleActivateKey = (event, action) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    action(event);
  }
};
